import Search from "../search/search";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MainBanner = () => {
  const { t } = useTranslation();
  return (
    <section
      className="w-full h-[70vh] relative z-50 opacity-0 animate-[showtitle_1s_forwards] max-sm:h-[300px] flex justify-center flex-col gap-5 items-center bg-cover bg-center"
      style={{
        animationDelay: ".2s",
      }}
    >
      <h1
        className="text-[80px] max-lg:text-[50px] max-sm:text-[30px] opacity-0 text-center w-full animate-[showtitle_1s_forwards] font-black uppercase text-white"
        style={{
          textShadow:
            window.innerWidth <= 640
              ? "none"
              : "5px 5px 0 black,-5px -5px 0 #006674,0 0 50px #006477",
          animationDelay: ".5s",
        }}
      >
        {t("bannertitle")}
      </h1>
      <div className="flex w-[1000px] max-lg:w-[700px] p-2 max-md:w-full justify-center items-start flex-col gap-6">
        <Search />
        <Link
          to=""
          className="text-[18px] max-sm:text-sm ml-4 opacity-0 animate-[showtitle_1s_forwards] text-white capitalize transition-all duration-200 hover:text-[#848484]"
          style={{ animationDelay: ".8s" }}
        >
          {t("freejobstitle")}
        </Link>
      </div>
    </section>
  );
};

export default MainBanner;
